// extracted by mini-css-extract-plugin
export default {"priceDifferenceRender_success":"styles_price-difference-render_success__WvuCq","priceDifferenceRender_danger":"styles_price-difference-render_danger__K1SUA"};